import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import icons from '../resources/icons';
import EsSearcher from './EsSearcher';
/**
 *
 * @class Searches gst geoservice (http://www.kortforsyningen.dk/dokumentation/geonoeglergeosearch)
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.PlanSearcher
 * @param {Object} options GeoSearch expects these properties:
 * @param options.area {string} "muncode" + municipalitycode eg.; "muncode0151"
 * @param options.authParams {Object} Either {ticket: 'ttttt'}, where t is a ticket issued by kortforsyningen or {login: 'lll', password: 'pppp'}
 *
 *
 */

export default Class(EsSearcher,
/**  @lends Septima.Search.PlanSearcher# */
{
  initialize: function initialize(options) {
    options.fields = ['plannavn', 'plannr', 'anvendelsegenerel', 'anvendelsespecifik', 'planid', 'wkt', 'doklink', 'komnr', 'datovedt'];
    options.searchindexServiceUrl = 'https://new-searchindex.septima.dk/';
    var searchindexToken = options.searchindexToken;
    options.index = searchindexToken + '/pdk/pdk_vedtaget';

    if (options.kommunekode) {
      var municipalities = options.kommunekode.split(' ');
      options.filterTerm = {
        'komnr': municipalities
      };
    } else if (options.filter) {
      options.filterTerm = options.filter;
    }

    if (typeof options.singular === 'undefined') options.singular = "Vedtaget lokalplan";
    if (typeof options.plural === 'undefined') options.plural = "Vedtagne lokalplaner";
    this.idField = "properties.planid";
    options.source = "Plansystem";
    options.type = "vedtaget lokalplan";
    EsSearcher.prototype.initialize.apply(this, [options]);
    this.iconURI = icons.searchers.planer.result;
  },
  createQuery: function createQuery(queryString) {
    //http://www.elasticsearch.org/guide/en/elasticsearch/guide/current/_cross_fields_queries.html
    var esQuery;
    esQuery = {
      "bool": {
        "should": [{
          "multi_match": {
            "query": queryString,
            "type": "cross_fields",
            "operator": "and",
            "fields": ["text", "plannavn", "planid", "plannr^2"]
          }
        }, {
          "match_phrase": {
            "plannavn": {
              "boost": 5,
              "query": queryString
            }
          }
        }, {
          "match": {
            "plannavn": {
              "boost": 4,
              "operator": "or",
              "query": queryString
            }
          }
        }, {
          "match_phrase": {
            "text": {
              "boost": 5,
              "query": queryString
            }
          }
        }, {
          "match_phrase": {
            "anvendelsespecifik": {
              "boost": 2,
              "query": queryString
            }
          }
        }, {
          "match_phrase": {
            "anvendelsegenerel": {
              "boost": 2,
              "query": queryString
            }
          }
        }]
      }
    };
    return esQuery;
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(id) {
      var cqlUrlurl, data, queryResult, feature, description, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cqlUrlurl = 'https://geoserver.plandata.dk/geoserver/wfs?servicename=WFS&typename=pdk:theme_pdk_lokalplan_vedtaget_v&request=GetFeature&version=1.0.0&outputformat=json&CQL_FILTER=planid=' + id;
              _context.next = 3;
              return fetch2(cqlUrlurl);

            case 3:
              data = _context.sent;
              queryResult = this.createQueryResult();
              feature = data.features[0];
              description = "";
              if (typeof feature.properties.anvendelsespecifik == "undefined") description = 'Plannummer ' + feature.properties.plannr;else description = 'Plannummer ' + feature.properties.plannr + ' - ' + feature.properties.anvendelsespecifik;
              result = queryResult.addResult(this.source, this.type, feature.properties.plannavn, description, feature.geometry, feature);
              result.id = id;
              return _context.abrupt("return", result);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query) {
      var querywkt, params, cqlUrlurl, data, queryResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, feature, description, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              querywkt = query.wkt;
              params = {
                servicename: 'WFS',
                typename: 'pdk:theme_pdk_lokalplan_vedtaget_v',
                request: 'GetFeature',
                version: '1.0.0',
                outputformat: 'json',
                CQL_FILTER: 'intersects(geometri,' + querywkt + ')'
              }; //let cqlUrlurl = 'https://geoserver.plandata.dk/geoserver/wfs?servicename=WFS&typename=pdk:theme_pdk_lokalplan_vedtaget_v&request=GetFeature&version=1.0.0&outputformat=json&CQL_FILTER=intersects(geometri,'+querywkt+')'

              cqlUrlurl = 'https://geoserver.plandata.dk/geoserver/wfs';
              _context2.next = 5;
              return fetch2(cqlUrlurl, {
                data: params,
                method: 'post'
              });

            case 5:
              data = _context2.sent;
              queryResult = this.createQueryResult();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 10;

              for (_iterator = data.features[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                feature = _step.value;
                description = "";
                if (typeof feature.properties.anvendelsespecifik == "undefined") description = 'Plannummer ' + feature.properties.plannr;else description = 'Plannummer ' + feature.properties.plannr + ' - ' + feature.properties.anvendelsespecifik;
                result = queryResult.addResult(this.source, this.type, feature.properties.plannavn, description, feature.geometry, feature);
                result.id = feature.properties.planid;
                result.distance = 0;
              }

              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 18:
              _context2.prev = 18;
              _context2.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context2.prev = 21;

              if (!_didIteratorError) {
                _context2.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context2.finish(21);

            case 25:
              return _context2.finish(18);

            case 26:
              return _context2.abrupt("return", queryResult);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[10, 14, 18, 26], [19,, 21, 25]]);
    }));

    function sq(_x2) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  getGeometry: function getGeometry(hit) {
    return this.translateWktToGeoJsonObject(hit.fields['properties.wkt'][0]);
  },
  getDescription: function getDescription(hit) {
    if (typeof hit.fields['properties.anvendelsespecifik'] == "undefined") return 'Plannummer ' + hit.fields['properties.plannr'][0];else return 'Plannummer ' + hit.fields['properties.plannr'][0] + ' - ' + hit.fields['properties.anvendelsespecifik'][0];
  },
  getDisplayName: function getDisplayName(hit) {
    return hit.fields['properties.plannavn'][0];
  },
  getPlanIdsForPoint: function () {
    var _getPlanIdsForPoint = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(point) {
      var coord, cqlFilter, cqlUrlurl, data, planIds, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, feature;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              coord = '' + point.coordinates[0] + ' ' + point.coordinates[1];
              cqlFilter = 'DWITHIN(geometri,POINT(' + coord + '),0,meters)';
              cqlUrlurl = 'https://geoserver.plandata.dk/geoserver/wfs?servicename=WFS&typename=pdk:theme_pdk_lokalplan_vedtaget_v&request=GetFeature&version=1.0.0&outputformat=json&CQL_FILTER=' + cqlFilter;
              _context3.next = 5;
              return fetch2(cqlUrlurl);

            case 5:
              data = _context3.sent;
              planIds = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context3.prev = 10;

              for (_iterator2 = data.features[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                feature = _step2.value;
                planIds.push(feature.properties.planid);
              }

              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](10);
              _didIteratorError2 = true;
              _iteratorError2 = _context3.t0;

            case 18:
              _context3.prev = 18;
              _context3.prev = 19;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 21:
              _context3.prev = 21;

              if (!_didIteratorError2) {
                _context3.next = 24;
                break;
              }

              throw _iteratorError2;

            case 24:
              return _context3.finish(21);

            case 25:
              return _context3.finish(18);

            case 26:
              return _context3.abrupt("return", planIds);

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[10, 14, 18, 26], [19,, 21, 25]]);
    }));

    function getPlanIdsForPoint(_x3) {
      return _getPlanIdsForPoint.apply(this, arguments);
    }

    return getPlanIdsForPoint;
  }(),
  getPlansForPoint: function () {
    var _getPlansForPoint = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(point) {
      var _this = this;

      var ids, ps;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getPlanIdsForPoint(point);

            case 2:
              ids = _context4.sent;
              ps = ids.map(function (id) {
                return _this.get(id);
              }, this);
              _context4.next = 6;
              return Promise.all(ps);

            case 6:
              return _context4.abrupt("return", _context4.sent);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getPlansForPoint(_x4) {
      return _getPlansForPoint.apply(this, arguments);
    }

    return getPlansForPoint;
  }(),
  CLASS_NAME: 'Septima.Search.PlanSearcher'
});